
import HomeView from '../views/front/home/index.vue'
import ArtView from '../views/front/art/home.vue'
import ArtMoreView from '../views/front/art/list.vue'
import ArtistView from '../views/front/artist/list.vue'
import CollectionView from '../views/front/assetStore/home.vue'
import CultureView from '../views/front/brand/index.vue'
import ArtDetailView from '../views/front/art/detail.vue'
import ArtistDetailView from '../views/front/artist/detail.vue'
import AssetsDetailView from '../views/front/assetStore/detail.vue'
import HelpCenterHomeView from '../views/front/helper/home.vue'
import HelpCenterDetailView from '../views/front/helper/detail.vue'
import CollectionListView from '../views/front/assetStore/cateList.vue'
import LoginView from '../views/front/login/index.vue'
import NewsView from '../views/front/news/list.vue'

export const routes = [
	{
		path: '/',
		name: 'home',
		component: HomeView
	},
	{
		path: '/art',
		name: 'art',
		component: ArtView
	},
	{
		path: '/art-more',
		name: 'art-more',
		component: ArtMoreView
	},
	{
		path: '/art-detail',
		name: 'art-detail',
		component: ArtDetailView
	},
	{
		path: '/artist',
		name: 'artist',
		component: ArtistView
	},
	{
		path: '/artist-detail',
		name: 'artist-detail',
		component: ArtistDetailView
	},
	{
		path: '/collection',
		name: 'collection',
		component: CollectionView
	},
	{
		path: '/collection-list',
		name: 'collection-list',
		component: CollectionListView
	},
	{
		path: '/culture',
		name: 'culture',
		component: CultureView
	},
	{
		path: '/assets-detail',
		name: 'assets-detail',
		component: AssetsDetailView
	},
	{
		path: '/help-center',
		name: 'help-center',
		component: HelpCenterHomeView
	},
	{
		path: '/help-center-detail',
		name: 'help-center-detail',
		component: HelpCenterDetailView
	},
	{
		path: '/login',
		name: 'login',
		component: LoginView
	},
	{
		path: '/news',
		name: 'news',
		component: NewsView
	},
]
